import React from 'react'
import PropTypes from 'prop-types'
import { Svg } from '../../1_Atoms/Svg/Svg'

function Modal({
  className,
  isOpen,
  isDark,
  children,
  ...otherProps
}) {
  return (
    <div
      className={`mz-modal ${className}`}
      aria-hidden={!isOpen} // Modal open/close will be handled in Core JS.
      {...otherProps}
    >
      <div className="mz-modal__inner mz-container">
        <div className="mz-modal__wrapper mz-full-width">
          <div className="mz-modal__close">
            <button
              className="mz-modal-close-button reset"
              aria-label="Close Modal"
            >
              <Svg
                type="x"
                size={1.875}
                colour={isDark ? 'white' : 'grey'}
              />
            </button>
          </div>
          <div className="mz-modal__content">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

Modal.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  isDark: PropTypes.bool,
};

Modal.defaultProps = {
  isOpen: false,
  isDark: false,
}

export default Modal

